import React, { useEffect, useState } from 'react';
import moment from 'moment';
import _ from 'lodash';
import {
	SdfBadge,
	SdfBox,
	SdfButton,
	SdfIcon,
	SdfInput,
	SdfLink,
	SdfMultiSelect,
	SdfTag,
	SdfTooltip
} from '@synerg/react-components';
import usFlag from '../assets/us-flag-5x.png';
import caFlag from '../assets/ca-flag-5x.png';
import { useHistory } from 'react-router-dom';
import './developmentProjects.scss';

export const DevelopmentProjects = (props = {}) => {
	const { devProjects, products, setJumpScrollIdProd, jumpScrollIdDev, setJumpScrollIdDev, isDataCloudUser } = props;

	const [showProjectsFilter, setProjectFilter] = useState(false);
	// eslint-disable-next-line no-unused-vars
	const [projectNameFilter, setProjectNameFilter] = useState('');
	const [selectedADPProducts, setADPProducts] = useState([]);
	const [projectList, setProjectList] = useState([]);
	const history = useHistory();

	const routeChange = (path) => {
		history.push(path);
	};

	const getDevProjectIdAndRedirect = (item) => {
		const pid = _.get(item, '_id', '');
		routeChange(`/projects/${pid}`);
	};

	const dropdownOnChange = (selectedList) => {
		setADPProducts(selectedList);
	};

	const onSearchChange = (searchValue) => {
		setProjectNameFilter(searchValue);
	};

	useEffect(() => {
		if (showProjectsFilter)
			clearFilters();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showProjectsFilter]);

	useEffect(() => {
		if (jumpScrollIdDev) {
			if (!showProjectsFilter) {
				setProjectFilter(true);
			} else {
				doJumpScroll();
			}
		}
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [jumpScrollIdDev]);

	useEffect(() => {
		if (showProjectsFilter) {
			setProjectList(devProjects);
		} else {
			setProjectList(devProjects.slice(0, 3));
		}
		doJumpScroll();
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [showProjectsFilter]);

	useEffect(() => {
    let list = devProjects.slice(0, 3);
		if (showProjectsFilter) {
      list = devProjects;

      if (projectNameFilter !== '') {
        list = list.filter((item) =>
					item.name.toLowerCase().includes(projectNameFilter.toLowerCase())
				);
      }

      if (selectedADPProducts && selectedADPProducts.length > 0) {
        let adpFilteredlist = [];
        selectedADPProducts.forEach((product) => {
          const _filteredData = _.filter(list, {
            product: product.label,
          });
          adpFilteredlist = adpFilteredlist.concat(_filteredData);
				});
        list = adpFilteredlist;
      }
    }

    setProjectList(list);
	// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [projectNameFilter, selectedADPProducts]);

	const clearFilters = () => {
		setProjectNameFilter('');
		setADPProducts([]);
		if (showProjectsFilter) {
			setProjectList(devProjects);
		} else {
			setProjectList(devProjects.slice(0, 3));
		}
	};

	const doJumpScroll = () => {
		if (jumpScrollIdDev) {
			clearFilters();
			setTimeout(() => {
				const elem = document.getElementById(jumpScrollIdDev);
				if (elem) {
					elem.scrollIntoView({
						behavior: 'smooth',
						block: 'center',
						inline: 'center'
					});
					elem.classList.add('focus-glow');
				}
			}, 500);
			setJumpScrollIdDev(null);
		}
	};

	const getProjectType = (b2bConsumerAppID, b2cConsumerAppID) => {
		return [
			b2cConsumerAppID ? 'End-user/SSO' : '',
			b2bConsumerAppID ? 'Data connector' : ''
		].join((b2bConsumerAppID && b2cConsumerAppID) ? ' + ' : '');
	};
  
	return (
		<div className="mt-10">
			<div className="grid grid-flow-row-dense grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 items-center">
				<div className="col-span-1">
					<div className="text-heading-06">
						<span className="font-black">My Development Projects </span>
						<span>
							{"(" + projectList.length + " of " + devProjects.length + ")"}
						</span>
					</div>
				</div>
				<div className="grid col-span-1 justify-end">
					<SdfLink class="cursor-pointer outline-none shadow-none"
						onClick={() => setProjectFilter(!showProjectsFilter)}
					>
						{showProjectsFilter ? (
							<div>Hide development projects{" "}<SdfIcon icon="nav-page-down" /></div>
						) : (
							<div>Show all development projects{" "}<SdfIcon icon="nav-page-up" /></div>
						)}
					</SdfLink>
				</div>
			</div>

			{showProjectsFilter && !isDataCloudUser && (
				<SdfBox variant="filled" spacing="default" className="mt-8">
					<div data-cvs-id="326"
						className="grid grid-flow-row-dense grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4"
					>
						<div data-cvs-id="327"
							className="col-span-3 sm:col-span-3 md:col-span-3 bg-gray-100 p-2"
						>
							<SdfInput
								id="project-search-input"
								className="w-full pr-6"
								label="Search"
								placeholder="Search by development project name"
								type="text"
								value={projectNameFilter}
								onSdfInput={(searchValue) => {
									searchValue.preventDefault();
									onSearchChange(searchValue.detail);
								}}
							>
								<SdfIcon slot="after" icon="action-search" />
							</SdfInput>
						</div>
						<div data-cvs-id="328" className="col-span-1 bg-gray-100 p-2">
							<SdfMultiSelect
								className="w-full"
								id="adp-product-multiselect"
								placeholder={
									selectedADPProducts.length > 0 ? "Selected" : "Select Product"
								}
								label="Filter by ADP Product"
								value={selectedADPProducts}
								items={products}
								input_width="xl"
								onSdfChange={(list) => dropdownOnChange(list.detail)}
							/>
						</div>
					</div>
					<div data-cvs-id="326" className="grid grid-flow-row-dense grid-cols-1 sm:grid-cols-3 lg:grid-cols-4 gap-4">
						<div data-cvs-id="327" className="col-span-3 sm:col-span-3 md:col-span-3 bg-gray-100 p-2">
							{selectedADPProducts && selectedADPProducts.map((item, index) => (
								<SdfTag
									className="bg-white rounded-full mr-2 mt-4"
									key={index}
									value={item.label}
									onClick={() => {
										if (selectedADPProducts.length === 1)
											setADPProducts([]);
										else {
											const filteredList = selectedADPProducts.filter(
												(product) => product.label !== item.label
											);
											setADPProducts(filteredList);
										}
									}}
								/>
							))}
							{selectedADPProducts.length > 0 &&
								<SdfButton className="ml-2 mt-4" variant="text"
									onClick={() => {
										dropdownOnChange([]);
										onSearchChange('');
									}}
								>
									Clear all
								</SdfButton>
							}
						</div>
						<div className="col-span-1 p-2" />
					</div>
				</SdfBox>
			)}

			<div className="grid grid-flow-row-dense grid-cols-1 sm:grid-cols-3 md:grid-cols-3 gap-5 mt-6 overflow-auto max-h-3xl p-2">
				{projectList.map((item, index) => (
					<div key={index} className=" flex flex-row col-span-1">
						<SdfBox
							className="box-shadow-style w-full min-w-full"
							data-cvs-id="3"
							id={item._id}
							variant="shadowed"
							spacing="default"
						>
							<div className="flex flex-col h-full justify-between">
								<div>
									<div className="inline-flex w-full gap-4">
										<div className="flex-1 w-4/5">
											<SdfTooltip className='order-2 text-heading-03'>
												<div slot="tooltip-target" className='text-heading-06 font-bold m-0 truncate text-ellipsis capitalize'>
													{item.name}
												</div>
												<span className='capitalize'>{item.name}</span>
											</SdfTooltip>
										</div>
										<div className="flex justify-end">
											{item.link && (
												<SdfLink className="cursor-pointer" external="">
													<SdfIcon
														icon="action-link"
														onClick={() => {
															// firs remove any old highlighted sections
															const highlightedElem =
																document.getElementsByClassName("focus-glow");
															if (highlightedElem) {
																while (highlightedElem[0]) {
																	highlightedElem[0].classList.remove(
																		"focus-glow"
																	);
																}
															}
															setJumpScrollIdProd(item.link);
														}}
													/>
												</SdfLink>
											)}
										</div>
									</div>
									<div className="text-body-02 font-bold pt-1">
										{getProjectType(item.b2bConsumerAppID, item.b2cConsumerAppID)}
									</div>
									<div className="mt-3">
										{item.type === "DEV" && (
											<SdfBadge spacing="default" status="in-progress">
												Development
											</SdfBadge>
										)}
										{item.type === "PROD" && (
											<SdfBadge spacing="default" status="complete">
												Production
											</SdfBadge>
										)}
										{item.legacy && (
											<SdfBadge className="ml-1" spacing="default" status="default">
												Legacy
											</SdfBadge>
										)}
									</div>
									<div className="text-body-01 mt-3 text-gray">
										Added {moment(item.createdDate).format("MMM DD, YYYY")}
									</div>
									<div className="text-body-01 mt-3">ADP product</div>
									<div className="text-heading-04 font-bold m-0">
										{item.product || 'NA'}
									</div>

									<div className="text-body-01 mt-3">Use case</div>
									<div className="text-heading-04 font-bold m-0">
										{item.caseDisplay || 'NA'}
									</div>
								</div>

								<div className="grid grid-flow-row-dense grid-cols-1 sm:grid-cols-2 md:grid-cols-2 gap-4 mt-6">
									<div className="col-span-1">
										<SdfButton
											action="standard"
											emphasis="secondary"
											size="sm"
											className="min-w-32"
											variant="contained"
											onClick={() => getDevProjectIdAndRedirect(item)}
										>
											View project
										</SdfButton>
									</div>
									{!isDataCloudUser && <div className="grid col-span-1 justify-items-end items-center">
										<img className="w-9" alt="" src={item.appStore === 'US' ? usFlag : caFlag} />
									</div>}
								</div>
							</div>
						</SdfBox>
					</div>
				))}
			</div>
		</div>
	);
}
